import LabLandingPage from '../../components/LabLandingPage';
import { LAB_PAGES } from '../../content/labPages';

export default function MathMistakeFinderPage() {
  return <LabLandingPage page={LAB_PAGES.math} />;
}
